import { Swiper, Navigation, Autoplay, Pagination } from 'swiper/js/swiper.esm.js';
// Install modules
Swiper.use([Navigation, Pagination, Autoplay]);

const slider = (() => {
  let sliderMain = null;
  const init = () => {
    const activeIndex = document.querySelector(".swiper-active-index");

    sliderMain = new Swiper('.slider-main', {
      speed: 3000,
      autoplay: true,
      loop: true,
      parallax: true,
      effect: "slide",
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      on: {
        slideChange: function () {
          if(activeIndex)
            activeIndex.innerHTML = this.realIndex + 1;
        }
      }
    });

    sliderMain = new Swiper('.slider-boxes', {
      autoplay: true,
      loop: true,
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true
      }
    });
  };

  return {
    init: init,
    sliderMain: sliderMain
  };
})();

export default slider;
